<script>
import find from 'lodash/find';
import {mapState} from 'vuex';

import mensCategoryImg from '@/assets/images/home/mens-category.png';
import womensCategoryImg from '@/assets/images/home/womens-category.png';
import kidsCategoryImg from '@/assets/images/home/kids-category.png';
import tShirtsCategoryImg from '@/assets/images/home/t-shirts-category.png';
import hoodiesCategoryImg from '@/assets/images/home/hoodies-category.png';
import accessoriesCategoryImg from '@/assets/images/home/accessories-category.png';
import ShopByCategoryImage from './HomeShopByCategoryImage';

export default {
  components: {
    ShopByCategoryImage,
  },
  data: () => ({
    mensCategoryImg,
    womensCategoryImg,
    kidsCategoryImg,
    tShirtsCategoryImg,
    hoodiesCategoryImg,
    accessoriesCategoryImg,
  }),
  computed: {
    ...mapState({
      categories: state => state.marketplace.categories,
    }),
    hobbiesCategory() {
      return this.categories ? find(this.categories.parent, category => category.category === 'Hobbies') : {};
    },
  },
};
</script>

<template lang='pug'>
.flex.container.mx-auto.mt-5.items-center.justify-between.flex-wrap.md_flex-no-wrap.text-center.md_text-left.px-3.md_px-1
  .text-4xl.md_text-3xl.text-brand-secondary-900.font-bold.md_mb-3.w-full.md_w-auto Shop by Category
  shop-by-category-image(
    fill='#dbebed',
    text='Hobbies',
    :route='{ name: "marketplace", query: { category: `${hobbiesCategory.id}` }, params: { page: "1" } }',
    :image='mensCategoryImg',
  )
  shop-by-category-image(
    fill='#eddbe0',
    text='Women\'s',
    :route='{ name: "marketplace", query: { product_type: "4" }, params: { page: "1" } }',
    :image='womensCategoryImg',
  )
  shop-by-category-image(
    fill='#ededdb',
    text='Kids',
    :route='{ name: "marketplace", query: { product_type: "9" }, params: { page: "1" } }',
    :image='kidsCategoryImg',
  )
  shop-by-category-image(
    fill='#e4dbed',
    text='T-shirts',
    :route='{ name: "marketplace", query: { product_type: "1" }, params: { page: "1" } }',
    :image='tShirtsCategoryImg',
  )
  shop-by-category-image(
    fill='#e4e6e7',
    text='Hoodies',
    :route='{ name: "marketplace", query: { product_type: "3" }, params: { page: "1" } }',
    :image='hoodiesCategoryImg',
  )
  shop-by-category-image(
    fill='#dbeddb',
    text='Accessories',
    :route='{ name: "marketplace", query: { product_type: "17" }, params: { page: "1" } }',
    :image='accessoriesCategoryImg',
  )
</template>

<style>
@import '~import/index';
</style>